import Faqs, { type FaqsProps } from './Faqs';

export type { FaqsProps };
export default Faqs;
